<template>
  <div class="report-wrapper">
    <!-- @click="toggleFullscreen(true)" -->
    <div class="report-small">
      <div class="report-small__header" @click="toggleFullscreen(true, true)">
        <div class="report-line" :class="[serviceName + '-color']"></div>
        <div style="position: relative">
          <p class="report-small__header__title">{{ graphData.title }}</p>
          <span class="toggle_style_text" v-show="showFullscreenButton">
            <img src="@img/fullscreen.svg" alt="" @click="toggleFullscreen(true)">
          </span>
        </div>
      </div>
      <div class="sort-buttons-group" v-if="type === 'bar' || type === 'bar_chart'">
        <div class="sort-button" @click="changeSort('value')">&#8593;&#8595;</div>
        <div class="sort-button" @click="changeSort('name')">a-z</div>
      </div>
      <graph class="report-small__content"
        :id="'report-small_' + id"
        :type="type"
        :graphData="graphData"
        :size="size"
        :dataSort="dataSort"
        :nameSort="nameSort"
        :barExtraOptions="{nameInside: true}"
        :mapExtraOptions="{roam: false, baseLayerName: baseLayerName }"/>
    </div>

    <div class="report-fullscreen" :id="'fullscreenWrapper' + id" v-if="fullscreen">
      <div class="report-fullscreen__wrapper">
        <div class="report-fullscreen__header">
          <button class="close-mobile-button close-mobile" @click="toggleFullscreen(false)">
            <img src="@img/arrow-white.svg" alt="">
          </button>
          <p class="report-fullscreen__header__title">
            {{ graphData.title }}
          </p>
          <div @click="toggleFullscreen(false)" class="report-fullscreen__header__close-button close-desctop">
            <img src="@img/close-gray.svg" alt="" class="report-fullscreen__header__close-button-img">
          </div>
        </div>
        <!-- <div class="report-fullscreen__content" :id="'reportContent_' + id"></div> -->
        <div class="sort-buttons-group-fullscreen" v-if="type === 'bar' || type === 'bar_chart'">
          <div class="sort-button" @click="changeSort('value')">&#8593;&#8595;</div>
          <div class="sort-button" @click="changeSort('name')">a-z</div>
        </div>
        <graph class="report-fullscreen__content"
          :id="'reportContent_' + id"
          :type="type"
          :graphData="graphData"
          :size="size"
          :dataSort="dataSort"
          :nameSort="nameSort"
          :mapExtraOptions="{roam: true, baseLayerName: baseLayerName }"/>
      </div>
    </div>
  </div>
</template>

<script>
import Graph from '@/components/utils/Graph'
// import MapReport from '@/components/main/reports/MapReport'
// import LineReport from '@/components/main/reports/LineReport'
// import PieReport from '@/components/main/reports/PieReport'
// import BarReport from '@/components/main/reports/BarReport'
// import TableReport from '@/components/main/reports/TableReport'
// import BarGroupReport from '@/components/main/reports/BarGroupReport'
// import Vue from 'vue'

import appStore from '@storages/appStore'

export default {
  name: 'report-component',
  props: ['id', 'type', 'graphData', 'size'],
  components: {
    'graph': Graph
  },

  data () {
    return {
      fullscreen: false,
      dataSort: 'none',
      nameSort: 'none',
      baseLayerName: null // используется для того, чтобы при открытии в фуллскрин создавать карту с той же подложкой что и на превью
    }
  },

  computed: {
    showFullscreenButton () {
      return document.body.clientWidth > 768
    },
    serviceName () {
      return appStore.getters.value('name')
    }
  },

  created () {
    this.$eventHub.$on('change-base-layer', this.setMapBaseLayer) // вызывается из mapChartMix при смене базового слоя
    if (this.type === 'bar' || this.type === 'bar_chart') {
      this.dataSort = 'ASC'
    }
  },

  methods: {
    setMapBaseLayer (e) { // если не хватает какт-то параметров в событии
      if (e === undefined || e.blockId === undefined || e.layerName === undefined) {
        return
      }
      if (e.blockId === 'report-small_' + this.id) { // если поменяли в превью, то меняем параметр с которым инициализируется фулскрин
        this.baseLayerName = e.layerName
        // console.log('change fullscreen')
      } else if (e.blockId === 'reportContent_' + this.id) { // если меняли в фулскрине, то вызываем событие чтобы поменять на превью
        e.blockId = 'report-small_' + this.id // используем id блока в котором превью(мы же в нем и меняем)
        this.$eventHub.$emit('change-preview-base-layer_report-small_' + this.id, e) // слушается в graph.vue
      }
    },

    changeSort (type) {
      if (type === 'value') {
        if (this.dataSort === 'ASC') {
          this.dataSort = 'DESC'
        } else {
          this.dataSort = 'ASC'
        }
      } else {
        if (this.nameSort === 'ASC') {
          this.nameSort = 'DESC'
        } else {
          this.nameSort = 'ASC'
        }
      }
    },

    toggleFullscreen (val, onlyMobile) {
      if (onlyMobile === true) {
        if (document.body.clientWidth <= 768) {
          this.fullscreen = val
          this.destroyPopup()
        } else {
          return
        }
      } else {
        this.fullscreen = val
        this.destroyPopup()
      }
      setTimeout(() => {
        this.setBobyScrollMix(!val, 'fullscreenWrapper' + this.id)
      }, 500)
      // let block = document.getElementById('reportContent_' + this.id)
      // // console.log(block.childElementCount)
      // if (val && block.childElementCount === 0) { // если открыли фулскрин и там нет сгенерериванных элементов
      //   var ComponentClass = null
      //   switch (this.type) {
      //     case 'map':
      //       ComponentClass = Vue.extend(MapReport)
      //       break

      //     case 'line_chart': case 'line':
      //       ComponentClass = Vue.extend(LineReport)
      //       break

      //     case 'bar_chart_group':
      //       ComponentClass = Vue.extend(BarGroupReport)
      //       break

      //     case 'pie_chart': case 'pie':
      //       ComponentClass = Vue.extend(PieReport)
      //       break

      //     case 'bar_chart': case 'bar':
      //       ComponentClass = Vue.extend(BarReport)
      //       break

      //     case 'table':
      //       ComponentClass = Vue.extend(TableReport)
      //       break

      //     default:
      //       console.error('fail generate element')
      //       break
      //   }
      //   var instance = new ComponentClass({
      //     propsData: {
      //       graphData: this.graphData,
      //       id: this.id,
      //       type: this.type,
      //       sort: this.sort
      //     }
      //   })
      //   instance.$mount()
      //   block.appendChild(instance.$el)
      // }
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/styles/varibles.scss';

$width-fullscreen: 100vw;
$height-fullscreen: 100vh;
$height-title-small: 47px;
$height-title-fullscreen: 30px;
$padding-x-title-fullscreen: 30px;
$padding-y-title-fullscreen: 20px;

$height-title-small__mobile: 25px;
$height-title-fullscreen__mobile: 50px;
$padding-left-title-fullscreen__mobile: 15px;
$padding-right-title-fullscreen__mobile: 15px;
$padding-x-title-fullscreen__mobile: calc(#{$padding-left-title-fullscreen__mobile} + #{$padding-right-title-fullscreen__mobile});
$padding-top-title-fullscreen__mobile: 25px;
$padding-bottom-title-fullscreen__mobile: 22px;
$padding-y-title-fullscreen__mobile: calc(#{$padding-top-title-fullscreen__mobile} + #{$padding-bottom-title-fullscreen__mobile});

.close-desctop {
  display: block;
}
.close-mobile {
  display: none;
}
.report-small {
  width: 100%;
  height: $Height-report-small-graph + $Height-report-small-title;
  position: relative;
  // overflow-y: auto;
}
.toggle_style_text {
  position: absolute;
  top: -7px;
  right: 20px;
  cursor: pointer;
}
.toggle_style_text img {
  width: 15px;
  height: 15px;
}

.report-small__header__title {
  width: calc(100% - 60px);
  font-size: 18px;
  font-weight: bold;
  height: $height-title-small;
  margin-top: 22px;
  margin-bottom: 6px;
  padding: 0 30px;
  color: #383838;
}
.report-small__content {
  position: relative;
  height: $Height-report-small-graph - 43px; // 20px - padding из .graphs в Main.vue
  overflow-y: auto;
  scrollbar-width: thin;
}
.report-fullscreen {
  position: fixed;
  z-index: 20;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.507);
  display: flex;
  align-items: center;
  justify-content: center;
}
.report-fullscreen__wrapper {
  width: $width-fullscreen;
  // height: calc(#{$Height-report-full-graph} + #{$height-title-fullscreen} + #{$padding-y-title-fullscreen});
  max-height: $height-fullscreen;
  background-color: white;
  border-radius: 3px;
  // overflow-y: auto;
  position: relative;
}
.report-fullscreen__header {
  width: calc(#{$width-fullscreen} - 60px); // $width-fullscreen - (padding-left - padding-right) + scroll
  height: $height-title-fullscreen;
  padding: $padding-y-title-fullscreen $padding-x-title-fullscreen;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  z-index: 10;
  background-color: white;
  // box-shadow: $Shadow;
  // border-bottom-color: #EBEDEF;
  // border-bottom-style: solid;
  // border-bottom-width: 1px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.report-line {
  width: 100%;
  height: 10px;
  // background-color: #316fea;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.eco-color {
  background-color: $eco-color;
}
.emergency-color {
  background-color: $emergency-color;
}
.quarry-color {
  background-color: $quarry-color;
}
.construction-color {
  background-color: $construction-color;
}
.legal-color {
  background-color: $legal-color;
}
.agro-color {
  background-color: $agro-color;
}
.forest-color {
  background-color: $forest-color;
}
.report-fullscreen__header__title {
  // font-weight: bold;
  font-size: 20px;
}
.report-fullscreen__header__close-button {
  cursor: pointer;
}
.report-fullscreen__header__close-button-img {
  width: 20px;
  height: 20px;
}
.report-fullscreen__content {
  position: relative;
  margin-top: $height-title-fullscreen + $padding-y-title-fullscreen + $padding-y-title-fullscreen; // отступ сверху на высоту хедера
  overflow-y: auto;
  // max-height: $Height-report-full-graph;
  height: calc(#{$height-fullscreen} - #{$height-title-fullscreen} - #{$padding-y-title-fullscreen} - #{$padding-y-title-fullscreen});
}
.sort-buttons-group {
  position: absolute;
  z-index: 2;
  // top: 0px;
  left: 31px;
  display: flex;
  border-radius: 10px;
  background-color: #DFEAFC;
  padding: 0 2px 2px;
}
.sort-buttons-group-fullscreen {
  position: absolute;
  z-index: 2;
  top: 72px;
  left: 31px;
  display: flex;
  border-radius: 10px;
  background-color: #DFEAFC;
  padding: 0 2px 2px;
}
.sort-button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px;
}
@media (min-width: 319px) and (max-width: 768px) {
  .sort-buttons-group {
    left: 10px;
    padding: 0 2px 2px;
  }
  .sort-buttons-group-fullscreen {
    top: 98px;
    left: 15px;
  }
  .close-desctop {
    display: none;
  }
  .close-mobile {
    display: block;
  }
  .close-mobile-button {
    width: 44px;
    height: 44px;
    background-color: #2d325a;
    border: none;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    // float: left;
    margin-right: 14px;
    flex: none;
    // align-self: flex-start;
  }
  .close-mobile-button img {
    height: 18px;
  }
  .report-small {
    height: calc(#{$Height-report-small-graph__mobile} + #{$Height-report-small-title__mobile} + 30px);
  }
  .report-small__header__title {
    margin: 0;
    font-size: 18px;
    padding: 10px;
    width: calc(100% - 20px);
    // height: calc(#{$height-title-small__mobile} - 20px);
    height: $Height-report-small-title__mobile;
  }
  .report-small__content {
    height: $Height-report-small-graph__mobile;
  }
  .toggle_style_text {
    top: 7px;
  }
  .report-fullscreen {
    animation: myAnimation ease-in;
    animation-duration: 500ms;
    animation-delay: 0s;
  }
  @keyframes myAnimation {
    0% {margin-left: 100vh}
    100% {margin-left: 0}
  }
  .report-fullscreen__wrapper {
    width: 100vw;
    height: auto;
    min-height: 100vh;
  }
  .report-fullscreen__header {
    width: calc(100vw - #{$padding-x-title-fullscreen__mobile}); // ширина экрана - паддинг
    padding: $padding-top-title-fullscreen__mobile $padding-right-title-fullscreen__mobile $padding-bottom-title-fullscreen__mobile $padding-left-title-fullscreen__mobile;
    height: $height-title-fullscreen__mobile;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .report-fullscreen__header__title {
    font-size: 18px;
    // line-height: 22px;
    font-weight: bold;
  }
  .report-fullscreen__header__close-button-img {
    width: 14px;
    height: 14px;
  }
  .report-fullscreen__content {
    margin-top: calc(#{$height-title-fullscreen__mobile} + #{$padding-y-title-fullscreen__mobile});
    height: calc(100vh - #{$height-title-fullscreen__mobile} - #{$padding-y-title-fullscreen__mobile}); // высота экрана - высота тайтла(через переменные не рассчитывает)
    max-height: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/Report.vue